var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmed = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#404C60",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.95 29c-2.083 0-4.142-.454-6.175-1.363-2.033-.908-3.883-2.195-5.55-3.862-1.667-1.667-2.954-3.517-3.863-5.55C11.455 16.192 11 14.133 11 12.05c0-.3.1-.55.3-.75.2-.2.45-.3.75-.3h4.05a.93.93 0 0 1 .625.238.913.913 0 0 1 .325.562l.65 3.5c.033.267.025.492-.025.675-.05.183-.142.342-.275.475l-2.425 2.45c.333.617.73 1.213 1.188 1.788.458.575.962 1.129 1.512 1.662.517.517 1.058.996 1.625 1.438.567.441 1.167.845 1.8 1.212l2.35-2.35a1.4 1.4 0 0 1 .588-.337 1.61 1.61 0 0 1 .712-.063l3.45.7c.233.067.425.188.575.363A.88.88 0 0 1 29 23.9v4.05c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3ZM14.025 17l1.65-1.65L15.25 13h-2.225c.083.683.2 1.358.35 2.025.15.667.367 1.325.65 1.975Zm8.95 8.95c.65.283 1.313.508 1.987.675.675.167 1.355.275 2.038.325v-2.2l-2.35-.475-1.675 1.675Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M28.242 12.172a1 1 0 0 1 0 1.414L24 17.828a1 1 0 0 1-1.414 0l-2.122-2.12a1 1 0 0 1 1.415-1.415l1.414 1.414 3.535-3.535a1 1 0 0 1 1.415 0Z",
  clipRule: "evenodd"
})));
SvgConfirmed.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmed);
export default ForwardRef;